<template>
    <div>
        <DialogoLlamame ref="llamar" :titulo="this.titulo" :key="dialogKey" />
        <v-card dense flat>
            <v-row class="d-flex align-center ma-0"
                :class="$vuetify.breakpoint.mdAndUp ? 'justify-space-between' : 'flex-column justify-center'">
                <v-col cols="12" md="8" class="font-weight-regular orange--text text--darken-3"
                    :class="$vuetify.breakpoint.mdAndUp ? 'text-left' : 'text-center'">
                    <v-icon color="orange darken-3" class="pr-1">mdi-alert</v-icon>
                    {{ texto }}
                </v-col>
                <v-col cols="12" md="4"
                    :class="$vuetify.breakpoint.mdAndUp ? 'd-flex justify-end' : 'd-flex justify-center'">
                    <v-btn v-if="mostrarBtn" class="elevation-0 pa-5" :block="$vuetify.breakpoint.smAndDown"
                        color="orange darken-3" dark @click="accion">
                        <v-icon>mdi-chevron-right</v-icon>
                        {{ textBtn }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import DialogoLlamame from '@/components/dialogos/DialogoLlamame.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        DialogoLlamame
    },
    data() {
        return {
            titulo: '',
            dialogKey: 0,
        }
    },

    methods: {
        accion() {
            if (this.tienedeuda == 1) {
                this.$router.push('/boletas').catch(() => { })
            } else {
                this.dialogKey = this.dialogKey + 1;
                this.titulo = 'QUIERO QUE ME LLAMEN'
                this.$nextTick(() => {
                    this.$refs.llamar.abrirDialogo().then(result => {
                        if (result)
                            return
                    });
                });
            }
        },
    },
    computed: {
        ...mapGetters('auth', ['user', 'tienedeuda']),

        mostrarBtn() {
            const currentPath = this.$route?.path || this.$router.currentRoute.path;
            //console.log('tienedeuda:', this.tienedeuda, 'currentPath:', currentPath);
            return !(this.tienedeuda == 1 && currentPath == '/boletas');
        },
        textBtn() {
            switch (this.tienedeuda) {
                case 1:
                    return 'ir a pagar'
                case 2:
                case 3:
                    return 'quiero que me llamen'
                default:
                    return 'ir a pagar'
                    break;
            }
        },
        texto() {
            switch (this.tienedeuda) {
                case 1:
                    return 'Existen conceptos adeudados'
                case 2:
                    return 'Tenés un plan de pago bloqueado'
                case 3:
                    return 'Tenés una deuda que se encuentra en juicio por apremio'
                default:
                    return 'No se han encontrado conceptos'
                    break;
            }
        }
    }


}
</script>